import React from 'react';

export default function DateTime() {
  return (
    <React.Fragment>
      It's a DateTime!
    </React.Fragment>
  );
}
